import { render, staticRenderFns } from "./ShopFeedback.vue?vue&type=template&id=67a95f55&scoped=true"
import script from "./ShopFeedback.vue?vue&type=script&lang=js"
export * from "./ShopFeedback.vue?vue&type=script&lang=js"
import style0 from "./ShopFeedback.vue?vue&type=style&index=0&id=67a95f55&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a95f55",
  null
  
)

export default component.exports